import {create} from "zustand";

const notificationStore = create((set) => ({
  notifications: null,
  countNoti: null,
  setNotification: (notifications) => set({notifications}),
  setCountNoti: (countNoti) => set({countNoti})
}));

export default notificationStore;
